import {Dialog, Notify, Toast} from 'vant';
import global from '../../static/gloabvar.js'
import $utils from './commonutils'

// // 请求拦截
export function reqInterceptors(config) {
  return config
}
/*
* HTTP响应拦截
* */
export function resInterceptors(response) {
 // console.log("response",response)
 if(response.data.code == 401 || response.data.code == 501) {
   if (response.config.url.indexOf("getInfo") < 0 && response.config.url.indexOf("getIstoken")<0) {
     Dialog.confirm({
       message: '<span style="color:red;font-size:13px;">登录状态已过期，请重新登录</span>'
     })
       .then(() => {
         localStorage.removeItem("Token");
         localStorage.removeItem('Identity');
         localStorage.removeItem('user');
         localStorage.removeItem("weakPass");
         if (localStorage.getItem("routerPath")) {
           window.location.href = global.assetsPublicPath + '#' + "/login?redirect=" + localStorage.getItem("routerPath");
         } else {
           window.location.href = global.assetsPublicPath + '#' + "/login";
         }

       })
       .catch(() => {
         // on cancel
       });
   }
 }
 if(response.data.code != 200
   && response.data.code != 401
   && response.config.url.indexOf("getInfo")<0
   && response.config.url.indexOf("getIstoken")<0) {
   Toast.fail(response.data.msg)
 }
  return $utils.rexFilterHtml(response.data)
}


/*
* HTTP响应拦截  error
* */
export function resErrInterceptors(error) {
  console.log(error);
  let {message} = error;
  if (message == "Network Error") {
    message = "后端接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常";
  }
  Toast.fail(message);
  return error;
}



// WEBPACK FOOTER //
// ./src/utils/interceptors.js